exports.default = {
    title: "Authoring Tool - CTI Blueprints"
}
